<template>
  <!-- <div :name="name">
    <div>
      {{ title }}
      <slot name="form-card-tag"></slot>
      <slot name="form-card-btn"></slot>
    </div>
    <slot></slot>
  </div> -->
  <el-collapse-item
    :name="name"
    :disabled="disabled_"
    :data-mark="name"
    :class="[
      'form-card-container',
      'form-card-border-' + borderRule,
      'padding-show-' + padding,
      { 'header-border-bottom': headerBorderBottom, 'collapse-hide-right': hideRight }
    ]"
  >
    <template slot="title">
      <div class="form-card-title">
        <cnd-icon v-if="shrink" name="cnd-arrow-right-on" /> {{ title }}
      </div>
      <slot v-if="$slots['form-card-tag']" name="form-card-tag" />
      <div v-if="$slots['form-card-btn']" class="form-card-btn" @click.stop @keyup.stop>
        <slot name="form-card-btn" />
      </div>
    </template>
    <!-- <div class="2222"> -->
    <slot />
    <!-- </div> -->
  </el-collapse-item>
</template>

<script>
import '../../../../lib/styles/components/FormCard.scss'
export default {
  name: 'FormCard',
  inject: ['formCardList'],
  props: {
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 边框
    borderRule: {
      // all、none、bottom、except-top、except-bottom、except-right、except-left、top-down、left-right
      type: String,
      default: 'none'
    },
    headerBorderBottom: {
      type: Boolean,
      default: false
    },
    // padding 待定
    paddingRule: {
      // all、seesaw、none、top
      type: Boolean,
      default: true
    },
    padding: {
      type: Number,
      default: 0
    },
    // 隐藏右侧
    hideRight: {
      type: Boolean,
      default: true
    },
    shrink: { // 是否可收缩
      type: Boolean,
      default: true
    }
  },
  computed: {
    disabled_() {
      return this.disabled || !this.shrink
    }
  },
  created() {
    if (this.formCardList && !this.shrink) {
      this.formCardList.openCardList.push(this.name)
    }
  }
}
</script>
